export function resolveMaasNodeGroupsPaths(_prefix: string): Record<string, string> {
  return {};
}
